module.exports = __webpack_public_path__ + "static/media/foot.ed433bdd.png";